import React from "react";

function SwapVert({ className }) {
  return (
    <div className="dark:text-dark-text">
      <svg
        className={className}
        width="14"
        height="15"
        viewBox="0 0 14 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.99978 14.2223L0.888672 8.11117L2.63034 6.40005L5.77756 9.54728V0.777832H8.222V9.54728L11.3692 6.40005L13.1109 8.11117L6.99978 14.2223Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}

export default SwapVert;
